import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import AppContentView from '../../AppContentView';
import AppFixedFooter from './AppFixedFooter';
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
import { useLayoutContext } from '@projectK/context/LayoutContextProvider';
import HorDefaultWrapper from './HorDefaultWrapper';
import MainContent from './MainContent';
import { LayoutType } from '@projectK/constants/AppEnums';
import HorDefaultContainer from './HorDefaultContainer';
import { useLocation } from 'react-router-dom';
import PropsTypes from 'prop-types';
import jwtAxios from '@projectK/services/auth/JWT';
import AppLoader from '@projectK/components/AppLoader';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import BottomNavigationBar from './BottomNavigationBar';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import IonicHeader from './IonicHeader';
const HorDefault = ({ routes, routesConfig, commonRoutes }) => {
  const { isMobile } = useMobileSettings();

  const { user } = useAuthUser();
  const { pathname } = useLocation();
  const { footer, layoutType, footerType } = useLayoutContext();
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);

  const toggleNavCollapsed = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };
  useEffect(() => {
    if (isNavCollapsed) setIsNavCollapsed(!isNavCollapsed);
  }, [pathname]);

  /***********************Social settings********************* */

  const [settings, setSettings] = useState(null);

  const fetchSettings = async () => {
    try {
      const response = await jwtAxios.get(`/public/app-settings/`);
      setSettings(response.data);
    } catch (error) {
      // Handle error
      console.error('Error fetching appearance settings:', error);
      if (error?.response?.data?.error === 'No Subdomain found') {
        window.location.href = `${process.env.NX_BASE_DOMAIN}/404`;
      }
    }
  };
  useEffect(() => {
    if (!isMobile) {
      fetchSettings();
    }
  }, [isMobile]);

  const webContent = !settings ? (
    <AppLoader />
  ) : (
    <MainContent>
      <AppHeader
        toggleNavCollapsed={toggleNavCollapsed}
        routesConfig={commonRoutes}
        socialSettings={settings?.social}
        companyData={settings?.basic}
      />
      <AppContentView routes={routes} />
      <AppFixedFooter
        location={settings?.location}
        companyData={settings?.basic}
        socialSettings={settings?.social}
      />
    </MainContent>
  );
  const allowedRoutes = [
    `/${user?.roleMenuFlag[0]}/product-listing`,
    `/${user?.roleMenuFlag[0]}/basic-calendar`,
    `/${user?.roleMenuFlag[0]}/events`,
    `/${user?.roleMenuFlag[0]}/settingsTab`,
  ];
  const showBottomBar =
    user &&
    allowedRoutes.some((route) => pathname.includes(route)) &&
    !pathname.includes('/student/waiver');
  return (
    <HorDefaultContainer
      className={clsx({
        boxedLayout: layoutType === LayoutType.BOXED,
        framedLayout: layoutType === LayoutType.FRAMED,
      })}
    >
      <HorDefaultWrapper
        className={clsx('horDefaultWrapper', {
          appMainFooter: footer && footerType === 'fluid',
          appMainFixedFooter: footer && footerType === 'fixed',
        })}
      >
        <AppSidebar
          routesConfig={routesConfig}
          isNavCollapsed={isNavCollapsed}
          toggleNavCollapsed={toggleNavCollapsed}
        />
        {!isMobile ? (
          webContent
        ) : (
          <MainContent>
            <IonicHeader
              toggleNavCollapsed={toggleNavCollapsed}
              routesConfig={commonRoutes}
              socialSettings={settings?.social}
              companyData={settings?.basic}
            />
            <AppContentView routes={routes} />
            {showBottomBar && (
              <BottomNavigationBar
                isNavCollapsed={isNavCollapsed}
                toggleNavCollapsed={toggleNavCollapsed}
              />
            )}
          </MainContent>
        )}
        {/* <AppThemeSetting /> */}
      </HorDefaultWrapper>
    </HorDefaultContainer>
  );
};
HorDefault.propTypes = {
  routes: PropsTypes.object.isRequired,
  routesConfig: PropsTypes.array.isRequired,
  commonRoutes: PropsTypes.array.isRequired,
};

export default HorDefault;
